// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

const AngleRight: React.FC<SvgProps> = (props) => (
  <Svg width="5.251" height="9.003" {...props} viewBox="0 0 5.251 9.003">
    <path
      id="パス_81"
      data-name="パス 81"
      d="M6.53-5.03a.751.751,0,0,1,0,1.062L2.78-.218a.751.751,0,0,1-1.062,0,.751.751,0,0,1,0-1.062L4.938-4.5,1.72-7.72a.751.751,0,0,1,0-1.062.751.751,0,0,1,1.062,0l3.75,3.75Z"
      transform="translate(-1.498 9.002)"
    />
  </Svg>
);

AngleRight.displayName = 'AngleRight';

export default AngleRight;
